/* ============================================================
   HYDRUS LEARNING CENTER — row carousel controls
   Desktop prev/next arrows + click-and-drag horizontal scroll.
   Consumed by: hydrus-lc-row sections (.lc-card-row).
   Singleton-guarded, idempotent, re-init on shopify:section:load.

   Desktop-only behavior:
   - Arrows are CSS-gated to fine pointers / >=769px viewports.
   - Drag-to-scroll only binds for pointerType === 'mouse', so native
     finger-swipe on touch devices is untouched.
   ============================================================ */
(function () {
  'use strict';

  if (window.__hydrusLcCarouselInit) return;
  window.__hydrusLcCarouselInit = true;

  // px the pointer must travel before a press becomes a "drag" (and the
  // card click is suppressed so a drag never opens an article).
  var DRAG_THRESHOLD = 6;

  function prefersReducedMotion() {
    return window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function updateArrowState(row, wrap, prevBtn, nextBtn) {
    // Overflow check: is there anything to scroll at all?
    var overflow = row.scrollWidth - row.clientWidth;
    if (overflow <= 1) {
      wrap.classList.remove('lc-has-arrows');
      return;
    }
    wrap.classList.add('lc-has-arrows');
    var atStart = row.scrollLeft <= 1;
    var atEnd = row.scrollLeft >= overflow - 1;
    prevBtn.classList.toggle('is-hidden', atStart);
    nextBtn.classList.toggle('is-hidden', atEnd);
    prevBtn.disabled = atStart;
    nextBtn.disabled = atEnd;
  }

  function pageScroll(row, direction) {
    var amount = row.clientWidth * 0.85 * direction;
    row.scrollBy({
      left: amount,
      behavior: prefersReducedMotion() ? 'auto' : 'smooth'
    });
  }

  function bindDrag(row) {
    var down = false;
    var dragging = false;
    var startX = 0;
    var startScroll = 0;

    row.addEventListener('pointerdown', function (e) {
      // Mouse only — leave native touch/pen swipe alone.
      if (e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      down = true;
      dragging = false;
      startX = e.clientX;
      startScroll = row.scrollLeft;
    });

    row.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragging && Math.abs(dx) > DRAG_THRESHOLD) {
        dragging = true;
        row.classList.add('is-dragging');
        // Capture so we keep getting moves even off the element.
        if (row.setPointerCapture) {
          try { row.setPointerCapture(e.pointerId); } catch (err) {}
        }
      }
      if (dragging) {
        e.preventDefault();
        row.scrollLeft = startScroll - dx;
      }
    });

    function endDrag(e) {
      if (!down) return;
      down = false;
      if (dragging) {
        // Suppress the click that would otherwise fire on the card.
        row.__lcSuppressClick = true;
        setTimeout(function () { row.__lcSuppressClick = false; }, 0);
      }
      dragging = false;
      row.classList.remove('is-dragging');
      if (row.releasePointerCapture && e && e.pointerId != null) {
        try { row.releasePointerCapture(e.pointerId); } catch (err) {}
      }
    }

    row.addEventListener('pointerup', endDrag);
    row.addEventListener('pointercancel', endDrag);

    // Capture-phase click swallow: if the press was a drag, stop the
    // card anchor from navigating.
    row.addEventListener('click', function (e) {
      if (row.__lcSuppressClick) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    // Don't let the browser start a native image/link drag mid-scroll.
    row.addEventListener('dragstart', function (e) {
      if (row.classList.contains('is-dragging')) e.preventDefault();
    });
  }

  function initRow(row) {
    if (!row || row.__lcCarouselBound) return;
    row.__lcCarouselBound = true;

    var wrap = row.closest('.lc-card-row-wrap');
    if (!wrap) return;
    var prevBtn = wrap.querySelector('.lc-row-arrow--prev');
    var nextBtn = wrap.querySelector('.lc-row-arrow--next');
    if (!prevBtn || !nextBtn) return;

    prevBtn.addEventListener('click', function () { pageScroll(row, -1); });
    nextBtn.addEventListener('click', function () { pageScroll(row, 1); });

    var schedule = (function () {
      var raf = null;
      return function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          updateArrowState(row, wrap, prevBtn, nextBtn);
        });
      };
    })();

    row.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);

    // Images load after init and change scrollWidth — recheck on load.
    row.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', schedule, { once: true });
    });

    bindDrag(row);
    updateArrowState(row, wrap, prevBtn, nextBtn);
  }

  function initAll() {
    document.querySelectorAll('.lc-card-row').forEach(initRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after a section rerender in the theme editor.
  document.addEventListener('shopify:section:load', initAll);
})();
